import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  stepCircle: ({ borderColor, backgroundColor }) => ({
    width: '1.5rem',
    height: '1.5rem',
    borderRadius: '50%',
    backgroundColor,
    border: ` 2px solid ${borderColor}`,
    zIndex: 1,
    position: 'absolute',
    left: '0',
    top: '50%',
    transform: 'translateY(-50%)',
  }),
  stepLine: ({ stepLineColor }) => ({
    borderLeft: `2px solid ${stepLineColor}`,
    height: '100%',
    position: 'absolute',
    left: '0.75rem',
    top: '50%',
    zIndex: 0,
  }),
}));

const palette = {
  brown: {
    borderColor: '#EFAA7E',
    stepLineColor: '#EFAA7E',
    backgroundColor: '#FBEADB',
  },
  brownSolid: {
    borderColor: '#EFAA7E',
    stepLineColor: '#EFAA7E',
    backgroundColor: '#EFAA7E',
  },
  yellow: {
    borderColor: '#FECA06',
    stepLineColor: '#FECA06',
    backgroundColor: '#FFF2C1',
  },
  yellowSolid: {
    borderColor: '#FECA06',
    stepLineColor: '#FECA06',
    backgroundColor: '#FECA06',
  },
  green: {
    borderColor: '#92C951',
    stepLineColor: '#92C951',
    backgroundColor: '#E4F1D3',
  },
  greenSolid: {
    borderColor: '#92C951',
    stepLineColor: '#92C951',
    backgroundColor: '#92C951',
  },
};

const StopStation = ({ last = false, color }) => {
  const classes = useStyles({ ...palette[color] });

  return (
    <>
      <div className={`${classes.stepCircle}`} />
      {!last && <div className={classes.stepLine} />}
    </>
  );
};

export default StopStation;
